/**
 *
 * ModalEditMeasure
 *
 */

import React from "react"
// import PropTypes from 'prop-types';
import { filter, isEqual } from "lodash"
import { Modal, Button, Input, Select, Spin, Radio, Popover } from "antd"
import "./index.less"

import questionIcon from "../../images/question.svg"

const { Option } = Select

/* eslint-disable react/prefer-stateless-function */
class ModalEditMeasure extends React.Component {
  state = {
    nameMeasurement: "",
    measureType: 1,
    id_survey: undefined,
    metricTotalLabel: "Clima laboral",
  }

  componentDidMount = () => {
    this.setState({
      nameMeasurement: this.props.nameMeasurement,
      id_survey: this.props.measure.id_survey,
      measureType: this.props.measure.id_measure_type || 1,
      metricTotalLabel: this.props.measure.metric_total_label,
    })
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (!isEqual(prevProps.nameMeasurement, this.props.nameMeasurement)) {
      this.setState({ nameMeasurement: this.props.nameMeasurement })
    }

    if (!isEqual(prevProps.measure, this.props.measure)) {
      this.setState({
        id_survey: this.props.measure.id_survey,
        measureType: this.props.measure.id_measure_type || 1,
      })
    }

    // eslint-disable-next-line
    if (!isEqual(prevProps.measure.metric_total_label, this.props.measure.metric_total_label)) {
      this.setState({ metricTotalLabel: this.props.measure.metric_total_label })
    }
  }

  handleCloseClick = () => {
    this.props.setStateFrom("modalEditMeasure", false)
    this.setState({
      nameMeasurement: this.props.nameMeasurement,
      id_survey: this.props.measure.id_survey,
      metricTotalLabel: this.props.measure.metric_total_label,
      measureType: this.props.measure.id_measure_type || 1,
    })
  }

  setStateFrom = (name, value) => {
    this.setState({ [name]: value })
  }

  showMetricTotalLabel = () => {
    const { measure } = this.props

    let response = true
    if (measure.id_survey_type === 2) {
      response = false
    }

    return response
  }

  disabledButton = () => {
    const { measure } = this.props

    let response = !this.state.nameMeasurement
    if (measure.id_survey_type === 1) {
      response = !this.state.nameMeasurement || !this.state.metricTotalLabel
    }

    return response
  }

  render() {
    const { measure } = this.props

    return (
      <Modal
        className="modal-edit-survey-header"
        title="Editar medición"
        visible={this.props.visible}
        style={{ top: 76 }}
        onCancel={() => this.handleCloseClick()}
        footer={[
          <Button key="back" onClick={() => this.handleCloseClick()}>
            Cancelar
          </Button>,
          <Button
            key="submit"
            type="primary"
            disabled={this.disabledButton()}
            onClick={() => {
              const { match } = this.props
              const params = {
                idMeasurement: match.params.id,
                params: {
                  name: this.state.nameMeasurement,
                  id_measure_type: this.state.measureType,
                  // id_survey: this.state.id_survey,
                  // metric_total_label: this.state.metricTotalLabel,
                },
              }

              this.props.setStateFrom("modalEditMeasure", false)
              this.props.editMeasurementNameWatcher(params)
            }}>
            Guardar
          </Button>,
        ]}
        width={520}>
        <div style={{ marginBottom: "1rem" }}>
          <strong style={{ fontWeight: "600" }}>Nombre de la medición*:</strong>
        </div>
        <Input
          style={{ width: "70%", marginBottom: 16 }}
          value={this.state.nameMeasurement}
          maxLength={200}
          onChange={(e) => this.setState({ nameMeasurement: e.target.value })}
        />
        {measure && [1, 2, 3].includes(measure.id_measure_status) && (
          <div>
            <div style={{ marginBottom: "8px" }}>
              <strong style={{ fontWeight: "600" }}>Tipo*: </strong>
            </div>
            <Radio
              checked={this.state.measureType === 1}
              value={1}
              style={{ display: "flex", alignItems: "center" }}
              onChange={(e) => {
                this.setStateFrom("measureType", e.target.value)
                // this.setState({ measureType: e.target.value })
              }}>
              Medición{" "}
              <Popover
                content={
                  <span className="type-description">
                    La medición es representativa de toda la población, por lo
                    que sus resultados serán considerados para el{" "}
                    <strong>análisis de la evolución histórica</strong> del
                    indicador a medir.
                  </span>
                }>
                <img src={questionIcon} />
              </Popover>
            </Radio>
            <Radio
              checked={this.state.measureType === 2}
              value={2}
              style={{ display: "flex", alignItems: "center" }}
              onChange={(e) => {
                this.setStateFrom("measureType", e.target.value)
                // this.setState({ measureType: e.target.value })
              }}>
              Pulso{" "}
              <Popover
                content={
                  <span className="type-description">
                    La medición <strong>no</strong> es representativa de toda la
                    población, por lo que sus resultados{" "}
                    <strong className="type-description-underline">no</strong>{" "}
                    serán considerados para el{" "}
                    <strong>análisis de la evolución histórica</strong> del
                    indicador a medir, ni contarán con evolución histórica
                    versus mediciones anteriores.
                  </span>
                }>
                <img src={questionIcon} />
              </Popover>
            </Radio>
          </div>
        )}
      </Modal>
    )
  }
}

ModalEditMeasure.propTypes = {}

export default ModalEditMeasure
